import { c as _c } from "react/compiler-runtime";
import { Card, HStack, SimpleGrid, Text } from '@chakra-ui/react';
import { FRAMEWORK_SLIDES } from '@src/components/sco/PitchDeckAuditor/model/framework';
import { ratingColorPalette, ratingLabel } from '@src/components/sco/PitchDeckAuditor/model/ratingMeta';
import { PitchDeckView } from '@src/components/sco/PitchDeckAuditor/model/types';

/** The 9-slide framework grid; clicking a covered category jumps to that slide. */
export function FrameworkScorecard(t0) {
  const $ = _c(6);
  const {
    deck,
    onSelectSlide
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      base: 1,
      sm: 2,
      lg: 3
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== deck || $[2] !== onSelectSlide) {
    t2 = FRAMEWORK_SLIDES.map(category => {
      const slide = deck.slides.find(s => s.classificationKey === category.key && s.isAudited);
      const ratingKey = slide?.ratingKey ?? "notAudited";
      const palette = ratingColorPalette(ratingKey);
      return <Card.Root key={category.key} _hover={slide ? {
        bg: "bg.muted"
      } : undefined} borderLeftColor={`${palette}.solid`} borderLeftWidth="4px" cursor={slide ? "pointer" : "default"} size="sm" variant={{
        _light: "outline",
        _dark: "subtle"
      }} onClick={() => slide && onSelectSlide(slide.pitchDeckSlideId)}><Card.Body py={3}><HStack justify="space-between"><Text fontSize="sm" fontWeight="semibold">{category.label}</Text>{slide?.score !== null && slide?.score !== undefined && <Text color="fg/50" fontFamily="mono" fontSize="xs" fontWeight="semibold">{slide.score}</Text>}</HStack><Text color={`${palette}.fg`} mt={0.5} textStyle="label2xs">{slide ? ratingLabel(ratingKey, slide.ratingLabel) : "Not Audited"}</Text></Card.Body></Card.Root>;
    });
    $[1] = deck;
    $[2] = onSelectSlide;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <SimpleGrid columns={t1} gap={3}>{t2}</SimpleGrid>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}